import { PROJECT_REQUEST_FAILURE, PROJECT_REQUEST_SUCCESS } from "../../constants/index";
import { onSuccess, onFailure } from "../common";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initStat, action) => {
  switch (action.type) {
    case PROJECT_REQUEST_SUCCESS:
      return onSuccess(state, action);
    case PROJECT_REQUEST_FAILURE:
      return onFailure(state, action);
    default:
      return { ...state };
  }
};
